import { ACTION_TYPES } from '../constants/actions';
import { Dispatch } from 'redux';
import { KeyValue } from '../types/common.types';

const initialState = {
  modified: false,
  orderActionAttributes: null,
  isRemoveBibSuccess: false,
  isAddBibSuccess: false,
  containmentIdData: {},
  isSkeletonLoading: false,
  manuallyAddedAddons: [],
  unRemovableAddons: [],
  pxAddonsProductOrderID: null,
  pxAddons: null,
  pxExistingAddons: null,
  pxAddonsError: false,
  pxAddonLoading: false
};

const addonsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADDONS_FETCH_LOADING': {
      return {
        ...state,
        modified: false,
        error: false,
        isRemoveBibSuccess: false,
        isAddBibSuccess: false,
        isBib: false,
        isSkeletonLoading: true
      };
    }
    case 'ADDON_ADD_LOADING':
    case 'ADDON_REMOVE_LOADING':
    case 'ADDON_UPGRADE_LOADING':
    case 'ADDON_SIM_ONLY_ADD_LOADING':
    case 'ADDON_REMOVE_ADD_LOADING':
      return {
        ...state,
        modified: false,
        loading: true,
        error: false,
        isRemoveBibSuccess: false,
        isAddBibSuccess: false,
        isBib: false
      };

    case 'ADDONS_FETCH_SUCCESS':
      return {
        ...state,
        atomicAddons: action.value.atomicAddons,
        availableAddons: action.value.availableAddons,
        selectedAddons: action.value.selectedAddons,
        selectedAddonsBo: action.value.selectedAddonsBo,
        addons5G: action.value.addons5G,
        bundleAddonsData: action.value.bundleAddonsData,
        containmentIdData: action.value.containmentIdData || {},
        unRemovableAddons: state.unRemovableAddons?.length
          ? state.unRemovableAddons
          : action.value.unRemovableAddons,
        modified: false,
        loading: false,
        error: false,
        isSkeletonLoading: false
      };
    case 'ADDON_REMOVE_ADD_SUCCESS':
    case 'ADDON_ADD_SUCCESS': {
      const manuallyAddedAddons = [
        ...state.manuallyAddedAddons,
        ...(typeof action.value === 'string' ? [action.value] : [])
      ];
      return {
        ...state,
        modified: true,
        loading: false,
        error: false,
        isRemoveBibSuccess: action.value?.isRemoveBib,
        isAddBibSuccess: action.value?.isAddBib,
        manuallyAddedAddons
      };
    }

    case 'ADDON_REMOVE_SUCCESS':
    case 'ADDON_UPGRADE_SUCCESS':
      return {
        ...state,
        modified: true,
        loading: false,
        error: false,
        isRemoveBibSuccess: action.value?.isRemoveBib,
        isAddBibSuccess: action.value?.isAddBib
      };

    case 'ADDON_SIM_ONLY_ADD_SUCCESS':
      return {
        ...state,
        modified: false,
        loading: false,
        error: false,
        selectedAddons: action.payload.selectedAddons
      };

    case 'ADDONS_FETCH_ERROR':
      return {
        ...state,
        availableAddons: null,
        selectedAddons: null,
        modified: false,
        loading: false,
        error: true,
        orderActionAttributes: null,
        isSkeletonLoading: false
      };
    case 'UPDATE_ORDER_ACTION_SUCCESS':
      return {
        ...state,
        orderActionAttributes: action.value
      };

    case 'ADDON_ADD_ERROR':
    case 'ADDON_REMOVE_ERROR':
    case 'ADDON_UPGRADE_ERROR':
    case 'ADDON_REMOVE_ADD_ERROR': {
      const isBibError = action.value?.isAddBib || action.value?.isRemoveBib;
      return {
        ...state,
        modified: false,
        loading: false,
        error: isBibError || action.value || true,
        isBib: isBibError,
        redirectNeeded: false
      };
    }

    case 'RESET_MODIFY_ADDON':
      return {
        ...state,
        modified: false
      };

    case ACTION_TYPES.ADDONS.RESET_UNKNOWN_ERROR: {
      return {
        ...state,
        error: false,
        loading: false
      };
    }
    case ACTION_TYPES.ADDONS.PX_ADDONS_FETCH_LOADING: {
      return { ...state, pxAddonLoading: true };
    }
    case ACTION_TYPES.ADDONS.PX_ADDONS_FETCH_SUCCESS: {
      return {
        ...state,
        pxAddonsProductOrderID: action.payload.productOrderId,
        pxAddons: action.payload.pxAddons,
        pxExistingAddons: action.payload.pxExistingAddons || null,
        pxAddonLoading: false
      };
    }

    case ACTION_TYPES.ADDONS.PX_ADDONS_RESET: {
      return {
        ...state,
        pxAddonsProductOrderID: null,
        pxAddons: null,
        pxAddonsError: false,
        pxExistingAddons: null,
        pxAddonLoading: false
      };
    }

    case ACTION_TYPES.ADDONS.PX_ADDONS_UPDATE: {
      return {
        ...state,
        pxAddons: action.payload.pxAddons,
        pxAddonLoading: false
      };
    }

    case ACTION_TYPES.ADDONS.PX_ADDONS_UPDATE_LOADING:
      return {
        ...state,
        pxAddonLoading: true
      };

    case ACTION_TYPES.ADDONS.PX_ADDONS_UPDATE_ERROR:
      return {
        ...state,
        pxAddonLoading: false,
        pxAddonsError: true
      };

    case ACTION_TYPES.ADDONS.BTL_ADDON_UPDATE: {
      return {
        ...state,
        btlAddon: action.payload
      };
    }

    default:
      return state;
  }
};

export const updateAddons = options => (dispatch: Dispatch) =>
  dispatch({
    type: ACTION_TYPES.ADDONS.ADDONS_FETCH_SUCCESS,
    value: options
  });

export const pxAddonsCalculateDispatch = (type: string, payload?: KeyValue) => (
  dispatch: Dispatch
) => dispatch({ type, ...(payload && { payload }) });

export default addonsReducer;
